import {
  Box,
  Divider,
  IconButton,
  InputAdornment,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import Grid from "@mui/material/Grid2";

import React, { useCallback, useState } from "react";
import { styled } from "@mui/material/styles";
import { getColorForIndex, maxLength } from "../../utilities";
import {
  Circle,
  Minus,
  Pen,
  PencilCircle,
  Plus,
  PlusCircle,
} from "@phosphor-icons/react";
import QuantityButtons from "../../components/common/CartQuantityButtons";
import CartQuantityButtons from "../../components/common/CartQuantityButtons";
import debounce from "lodash.debounce";
import UnAvailableTag from "../../components/common/UnAvailable";

function AddonItem({ cartLength, index, addon, updateAddonQtyMutate }) {
  const discountPrice = +addon.price * +addon.quantity;

  return (
    <>
      <Box display={"flex"} flexDirection={"row"} gap={3} marginTop={5}>
        <CartImage src={addon?.image} alt={addon?.product_name} />
        {addon?.cart_addons?.active_status == 0 && <UnAvailableTag />}

        <Box
          sx={{
            gap: 1,
            display: "flex",
            flexDirection: "column",
            width: "100%",
          }}
        >
          <CakeName>{addon?.product_name}</CakeName>

          <Stack direction="row" spacing={2} alignItems={"center"}>
            <Typography
              variant="h3"
              sx={{
                fontWeight: 600,
                fontSize: "16px",
                lineHeight: "150%",
                color: "var(--neutral-black)",
                textAlign: "left",
              }}
            >
              ₹ {discountPrice}
            </Typography>
          </Stack>
          <Box
            display={"flex"}
            justifyContent={"space-between"}
            alignItems={"center"}
          >
            <CartQuantityButtons
              updateCartQtyMutate={updateAddonQtyMutate}
              cartId={addon?.addon_id}
              customerId={addon?.customer_id}
              currentQty={addon?.quantity}
            />
          </Box>
        </Box>
      </Box>
      {index !== cartLength - 1 && <Divider variant="middle" sx={{ my: 3 }} />}
    </>
  );
}

const CartImage = styled("img")(({ theme, index }) => ({
  backgroundColor: getColorForIndex(index),
  textAlign: "center",
  width: "144px",
  //   height: "144px",
  borderRadius: "8px",
  cursor: "pointer",
}));
const CakeName = styled("h3")(({ theme }) => ({
  margin: 0,
  fontWeight: 600,
  fontSize: "14px",
  lineHeight: "150%",
  color: "var(--neutral-black)",
  textAlign: "left",
  textTransform: "capitalize",
  display: "-webkit-box",
  WebkitBoxOrient: "vertical",
  WebkitLineClamp: 2, // ✅ limit to 2 lines
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "normal", // ✅ allow wrapping
}));

export default AddonItem;
